export default "__VITE_ASSET__CjDMyta1__"